import { io } from 'socket.io-client'
import constants from '@/helpers/constants'

const socket = io(constants.socketBaseURL, {
  path: '/socket.io',
  transports: ['polling'],
  autoConnect: true,
  reconnection: true,
  reconnectionAttempts: Infinity,
  reconnectionDelay: 800,
  timeout: 15000
})

socket.on('connect', () => console.log('[SOCKET] connect', socket.id))
socket.on('connect_error', (e) => console.error('[SOCKET] connect_error', e))
socket.on('disconnect', (r) => console.warn('[SOCKET] disconnect', r))

export default socket
